<template>
  <a-dropdown>
    <span class="action global-lang">
      <a-icon type="global" style="font-size: 16px"/>
    </span>
    <a-menu slot="overlay" style="width: 150px;" @click="SwitchLang">
      <a-menu-item key="zh-CN">
        <a rel="noopener noreferrer">
          <span role="img" :aria-label="$t('toolsLangSelect.simplifiedChinese')">🇨🇳</span> {{ $t('toolsLangSelect.simplifiedChinese') }}
        </a>
      </a-menu-item>
      <a-menu-item key="zh-TW">
        <a rel="noopener noreferrer">
          <span role="img" :aria-label="$t('toolsLangSelect.traditionalChinese')">🇭🇰</span> {{ $t('toolsLangSelect.traditionalChinese') }}
        </a>
      </a-menu-item>
      <a-menu-item key="en-US">
        <a rel="noopener noreferrer">
          <span role="img" aria-label="English">🇬🇧</span> English
        </a>
      </a-menu-item>
<!--      <a-menu-item key="pt-BR">-->
<!--        <a rel="noopener noreferrer">-->
<!--          <span role="img" aria-label="Português">🇧🇷</span> Português-->
<!--        </a>-->
<!--      </a-menu-item>-->
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mixin as langMixin } from '@/store/i18n-mixin'

export default {
  name: 'LangSelect',
  mixins: [langMixin],
  data () {
    return {}
  },
  methods: {
    SwitchLang (row) {
      this.setLang(row.key)
      console.log("切换语言 刷新页面")

    }
  }
}
</script>
